module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray@2x-be195d8c3e65e3d08d2a43f994778bfb.png";